import React, { Component } from 'react';
import { Checkbox } from 'semantic-ui-react';
import moment from 'moment';

import {
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_DB_STRING,
} from 'Common/Constants';
import { SemanticUiColorsEnum } from 'Common/Constants/SemanticUiColors.js';
import { AlternateProvisionTypeEnum } from 'Common/Constants/Enumeration/AlternateProvisionTypeEnum.js';
import {
  VerificationStatusEnum,
  ExcludedVerificationStatuses,
  VerificationStatusesAllowingDelete,
} from 'Common/Constants/Enumeration/VerificationStatusEnum';

export class ApplicationObjects extends Component {
  alternateProvisionTypes = [
    AlternateProvisionTypeEnum.Provision2_base,
    AlternateProvisionTypeEnum.Provision2_Non_Base,
    AlternateProvisionTypeEnum.CEP,
    AlternateProvisionTypeEnum.Prov2_Non_Base_Breakfast_Only,
  ];

  showStatus = (original, accessor) => {
    return (
      <div style={{ textAlign: 'center' }}>
        <Checkbox checked={original[accessor] === 'Yes'} disabled={true} />
      </div>
    );
  };

  onEditClick = (application, isSecondReview, isVerficationApp) => {
    if (isSecondReview) {
      this.props.history.push(
        `/manageapplication/${application.FamilyId}?secondReview=1&verification=0`
      );
    } else if (isVerficationApp) {
      this.props.history.push(
        `/manageapplication/${application.FamilyId}?secondReview=0&verification=1`
      );
    } else {
      this.props.history.push(
        `/manageapplication/${application.FamilyId}?secondReview=0&verification=0`
      );
    }
  };

  onHistoryClick = (application) => {
    this.props.history.push(
      `/manageapplication/history/${application.FamilyId}`
    );
  };

  onNotesClick = (application) => {
    this.setState({
      studentData: {
        HouseholdId: application.HouseholdId,
        FirstName: application.StudentFirstName,
        LastName: application.StudentLastName,
        HouseholdFirstName: application.HouseholdFirstName,
        HouseholdLastName: application.HouseholdLastName,
      },
      showNotesModal: true,
    });
  };

  //? Reprints the Notification Letter for an Application
  onPrintLetterClick = ({ FamilyId }) => {
    this.props.printLetterByFamilyId(FamilyId);
  };

  onPrintClick = ({ FamilyId }) => {
    this.props.getReport('Application/PrintHouseholdApplication', { FamilyId });
  };

  onDeleteClick = (application) => {
    this.setState({ showDeleteModal: true, deleteApp: application });
  };

  onCopyToNewAppClick = ({ FamilyId }) => {
    this.props.fetchApplication(FamilyId, true);
  };

  onDeclineToVerifyClick = (app) => {
    this.props.declineToVerify(app.FamilyId);
  };

  activeMenuOptions = (application, verificationComplete) => {
    const verificationStatuses = Object.values(VerificationStatusEnum);
    const viewOnly =
      verificationStatuses.includes(application.VerificationStatus) &&
      !ExcludedVerificationStatuses.includes(application.VerificationStatus) &&
      !verificationComplete;

    const canDeleteApplication =
      !application.VerificationStatus ||
      VerificationStatusesAllowingDelete.includes(
        application.VerificationStatus
      );

    return [
      {
        icon: viewOnly ? 'eye' : 'pencil',
        text: viewOnly ? 'View' : 'View/Edit',
        handler: (x) => this.onEditClick(x, false),
      },
      {
        icon: 'history',
        text: 'History',
        handler: this.onHistoryClick,
      },
      {
        icon: 'sticky note',
        text: 'Notes',
        handler: this.onNotesClick,
      },
      {
        icon: 'mail outline',
        text: 'Re-print Letter',
        handler: (x) => this.onPrintLetterClick(x),
        disabledWhen: (y) =>
          y.NotificationPrinted === 'N' && y.DirectCertifiedPrinted === 'N',
      },
      {
        icon: 'print',
        text: 'Print Application',
        handler: (x) => this.onPrintClick(x),
      },
      {
        icon: 'trash',
        text: 'Delete',
        className: 'danger',
        handler: this.onDeleteClick,
        disabledWhen: () => !canDeleteApplication,
      },
    ];
  };

  activeColumns = [
    {
      Header: 'Family #',
      accessor: 'FamilyId',
      filterable: true,
      resizable: true,
      maxWidth: 100,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          Last Name
        </div>
      ),
      accessor: 'HouseholdLastName',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          First Name
        </div>
      ),
      accessor: 'HouseholdFirstName',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Last Name',
      accessor: 'StudentLastName',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'First Name',
      accessor: 'StudentFirstName',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'MI',
      accessor: 'StudentMiddleInitial',
      filterable: true,
      resizable: true,
      width: 30,
    },
    {
      Header: 'Student #',
      accessor: 'StudentId',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Site Id',
      accessor: 'SiteId',
      getProps: (state, rowInfo) => {
        return {
          style: {
            color:
              rowInfo &&
              rowInfo.original &&
              this.alternateProvisionTypes.indexOf(
                rowInfo.original.AlternateProvisionTypeId
              ) > 0
                ? 'blue'
                : '',
          },
        };
      },
      filterable: true,
      resizable: true,
      width: 100,
    },
    {
      Header: (
        <div>
          Current
          <br />
          Status
        </div>
      ),
      accessor: 'StatusCurrent',
      filterable: true,
      resizable: true,
      width: 60,
    },
    {
      Header: (
        <div>
          Future
          <br />
          Status
        </div>
      ),
      accessor: 'StatusFuture',
      filterable: true,
      resizable: true,
      width: 60,
    },
    {
      Header: 'Expiration Date',
      accessor: 'ExpirationDate',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          Release
          <br />
          Category
        </div>
      ),
      accessor: 'ReleaseCategory',
      filterable: true,
      resizable: true,
      width: 100,
    },
    {
      Header: (
        <div>
          Direct
          <br />
          Certified?
        </div>
      ),
      accessor: 'DirectCertified',
      filterable: false,
      resizable: false,
      width: 100,
      Cell: ({ original }) => this.showStatus(original, 'DirectCertified'),
    },
  ];

  secondReviewMenuOptions = (isSameUser) => {
    const secondReviewOptions = isSameUser
      ? [
          {
            icon: 'eye',
            text: 'View',
            handler: (x) => this.onEditClick(x, true),
          },
          {
            icon: 'history',
            text: 'History',
            handler: this.onHistoryClick,
          },
          {
            icon: 'sticky note',
            text: 'Notes',
            handler: this.onNotesClick,
          },
        ]
      : [
          {
            icon: 'pencil',
            text: 'View/Edit',
            handler: (x) => this.onEditClick(x, true, false),
          },
          {
            icon: 'history',
            text: 'History',
            handler: this.onHistoryClick,
          },
          {
            icon: 'sticky note',
            text: 'Notes',
            handler: this.onNotesClick,
          },
          {
            icon: 'trash',
            text: 'Delete',
            className: 'danger',
            handler: this.onDeleteClick,
          },
        ];
    return secondReviewOptions;
  };

  getColor = (remainingDays) => {
    if (remainingDays >= 7) {
      return SemanticUiColorsEnum.GREEN;
    }
    if (remainingDays >= 4 && remainingDays <= 6) {
      return SemanticUiColorsEnum.YELLOW;
    }
    if (remainingDays >= 0 && remainingDays <= 3) {
      return SemanticUiColorsEnum.ORANGE;
    }

    return SemanticUiColorsEnum.RED;
  };

  secondReviewColumns = [
    {
      Header: 'Remaining Days',
      accessor: 'RemainingDays',
      filterable: true,
      resizable: true,
      getProps: (state, rowInfo) => {
        if (rowInfo && rowInfo.original) {
          return {
            style: {
              color: this.getColor(rowInfo.original.RemainingDays),
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: '18px',
              textShadow:
                rowInfo.original.RemainingDays >= 4 &&
                rowInfo.original.RemainingDays <= 6
                  ? '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000'
                  : '',
            },
          };
        } else {
          return {};
        }
      },
    },
    {
      Header: 'Family #',
      accessor: 'FamilyId',
      filterable: true,
      resizable: true,
      maxWidth: 100,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          Last Name
        </div>
      ),
      accessor: 'HouseholdLastName',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          First Name
        </div>
      ),
      accessor: 'HouseholdFirstName',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Last Name',
      accessor: 'StudentLastName',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'First Name',
      accessor: 'StudentFirstName',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Student #',
      accessor: 'StudentId',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Site Id',
      accessor: 'SiteId',
      getProps: (state, rowInfo) => {
        return {
          style: {
            color:
              rowInfo &&
              rowInfo.original &&
              this.alternateProvisionTypes.indexOf(
                rowInfo.original.AlternateProvisionTypeId
              ) > 0
                ? 'blue'
                : '',
          },
        };
      },
      filterable: true,
      resizable: true,
      width: 100,
    },
    {
      Header: 'Grade',
      accessor: 'GradeId',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          Current
          <br />
          Status
        </div>
      ),
      accessor: 'StatusCurrent',
      filterable: true,
      resizable: true,
      width: 60,
    },
    {
      Header: (
        <div>
          Future
          <br />
          Status
        </div>
      ),
      accessor: 'StatusFuture',
      filterable: true,
      resizable: true,
      width: 60,
    },
    {
      Header: 'Expiration Date',
      accessor: 'ExpirationDate',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Application Date',
      accessor: 'ApplicationDate',
      filterable: true,
      resizable: true,
      getProps: (state, rowInfo) => {
        return { style: { textAlign: 'left' } };
      },
      Cell: (original) => {
        if (original.value !== null) {
          const date = moment(original.value, DATE_FORMAT_FOR_DB_STRING);
          return date.format(DATE_FORMAT_FOR_UI);
        }
      },
    },
    {
      Header: 'User Name',
      accessor: 'UserName',
      filterable: true,
      resizable: true,
    },
  ];

  archivedMenuOptions = () => [
    {
      icon: 'eye',
      text: 'View',
      handler: (x) => this.onEditClick(x, false),
    },
    {
      icon: 'history',
      text: 'History',
      handler: this.onHistoryClick,
      // disabledWhen: () => this.props.isReadOnly,
    },
    {
      icon: 'print',
      text: 'Print Application',
      handler: (x) => this.onPrintClick(x),
    },
    {
      icon: 'sticky note',
      text: 'Notes',
      handler: this.onNotesClick,
      // disabledWhen: () => this.props.isReadOnly,
    },
    {
      icon: 'copy',
      text: 'Copy to New App',
      handler: this.onCopyToNewAppClick,
    },
  ];

  archivedColumns = [
    {
      Header: 'Family #',
      accessor: 'FamilyId',
      filterable: true,
      resizable: true,
      maxWidth: 100,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          Last Name
        </div>
      ),
      accessor: 'HouseholdLastName',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          First Name
        </div>
      ),
      accessor: 'HouseholdFirstName',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          Student
          <br />
          Last Name
        </div>
      ),
      accessor: 'StudentLastName',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          Student
          <br />
          First Name
        </div>
      ),
      accessor: 'StudentFirstName',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Student #',
      accessor: 'StudentId',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Fiscal Year',
      accessor: 'FiscalYear',
      filterable: true,
      resizable: true,
      width: 100,
    },
    {
      Header: (
        <div>
          Actual
          <br />
          Archived Date
        </div>
      ),
      accessor: 'ActualArchiveDate',
      filterable: true,
      resizable: true,
    },
  ];

  deletedMenuOptions = () => [
    {
      icon: 'eye',
      text: 'View',
      handler: (x) => this.onEditClick(x, false),
    },
    {
      icon: 'history',
      text: 'History',
      handler: this.onHistoryClick,
      // disabledWhen: () => this.props.isReadOnly,
    },
    {
      icon: 'print',
      text: 'Print Application',
      handler: (x) => this.onPrintClick(x),
    },
    {
      icon: 'sticky note',
      text: 'Notes',
      handler: this.onNotesClick,
      // disabledWhen: () => this.props.isReadOnly,
    },
  ];

  deletedColumns = [
    {
      Header: 'Family #',
      accessor: 'FamilyId',
      filterable: true,
      resizable: true,
      maxWidth: 100,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          Last Name
        </div>
      ),
      accessor: 'HouseholdLastName',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          First Name
        </div>
      ),
      accessor: 'HouseholdFirstName',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          SSN
        </div>
      ),
      accessor: 'HouseHouldSSN',
      filterable: true,
      resizable: true,
    },
  ];

  verificationColumns = [
    {
      Header: 'Family #',
      accessor: 'FamilyId',
      filterable: true,
      resizable: true,
      maxWidth: 100,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          Last Name
        </div>
      ),
      accessor: 'HouseholdLastName',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          First Name
        </div>
      ),
      accessor: 'HouseholdFirstName',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          SSN
        </div>
      ),
      accessor: 'HouseHouldSSN',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Verification Status',
      accessor: 'VerificationStatus',
      filterable: true,
      resizable: true,
    },
  ];

  verificationMenuOptions = (
    props,
    availableToDecline,
    verificationComplete
  ) => {
    var options = [
      {
        icon: 'pencil',
        text: verificationComplete ? 'View' : 'View/Edit',
        handler: (x) => this.onEditClick(x, false, true),
      },
    ];
    if (availableToDecline > 0 && !props.VerificationSelectPrinted) {
      options = options.concat([
        {
          icon: 'cancel',
          text: 'Decline to verify',
          handler: this.onDeclineToVerifyClick,
        },
      ]);
    }
    return options;
  };
}



// WEBPACK FOOTER //
// ./src/pages/manageapplication/helpers/ApplicationObjects.js